import type { FieldFormat, ValueTone } from '@crm/contracts';
import type { BadgeVariant } from '../components/ui/badge.tsx';

/** The one tone → colour mapping of every value pill: green, yellow, red. */
export const TONE_VARIANT: Record<ValueTone, BadgeVariant> = {
  positive: 'success',
  caution: 'caution',
  negative: 'danger',
};

/** A stage's outcome group as a tone: won is positive, lost negative, still open caution. */
export const stageTone = (group: string | null | undefined): ValueTone =>
  group === 'won' ? 'positive' : group === 'lost' ? 'negative' : 'caution';

/** Candidates' expected hourly rate: shown in dollars, coloured by how affordable it is. */
export const HOURLY_RATE_FORMAT: FieldFormat = {
  prefix: '$',
  bands: [{ upTo: 10, tone: 'positive' }, { upTo: 15, tone: 'caution' }, { tone: 'negative' }],
};

/** `n` calendar months before `now`, the day clamped to the target month's last day. */
const monthsBefore = (now: Date, n: number): Date => {
  const d = new Date(now);
  d.setDate(1);
  d.setMonth(d.getMonth() - n);
  d.setDate(Math.min(now.getDate(), new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()));
  return d;
};

/** A list date's age as a tone: last 3 months green, last 12 yellow, older red; future is recent. */
export const dateTone = (iso: unknown, now: Date = new Date()): ValueTone | undefined => {
  if (typeof iso !== 'string' || !iso) return undefined;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return undefined;
  if (t >= monthsBefore(now, 3).getTime()) return 'positive';
  return t >= monthsBefore(now, 12).getTime() ? 'caution' : 'negative';
};
